import * as Sentry from '@sentry/browser';

export const CAPTURED_ERROR_PREFACE = 'CE Captured error:';

/** We use this instead of doing console.error(someErrorObject) because passing
 * the error object through the console makes Sentry lose the stack trace.
 */
export const captureErrorInSentryWithCustomMessage = (
  error: unknown,
  message: string,
) => {
  Sentry.captureException(error, (scope) =>
    scope.setExtra('CE_message', message));
  // CAPTURED_ERROR_PREFACE should be ignored by Sentry filters,
  // so that this doesn't get double-reported in Sentry:
  console.error(`${CAPTURED_ERROR_PREFACE} ${message}`, error);
};
